<template>
  <div>
    <customize-form :schema="formModel" ref="form" />
  </div>
</template>

<script>
import CustomizeForm from './customize-form'
import {
  getCustomerOverview,
  getSelectList,
} from 'views/client/client-center/detail/mechanism/api'
export default {
  components: {
    CustomizeForm,
  },
  data() {
    return {
      formModel: [
        {
          type: 'select',
          label: '国家',
          key: 'country',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          selectList: [],
        },
        {
          type: 'input',
          label: '公司名称',
          key: 'companyName',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          type: 'select',
          label: '语言',
          key: 'inLanguage',
          rules: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
          value: 'en-US',
          selectList: [
            {
              id: 'ja-JP',
              name: 'Japanese',
            },
            {
              id: 'zh-hans-CN',
              name: 'Simplified Chinese',
            },
            {
              id: 'zh-hant-TW',
              name: 'Traditional Chinese',
            },
            {
              id: 'ko-hang-KR',
              name: 'Hangul',
            },
            {
              id: 'en-US',
              name: 'English',
            },
          ],
        },
      ],
    }
  },
  created() {
    this._getCustomerInfo()
    this._getCountryList()
  },

  methods: {
    async _getCustomerInfo() {
      try {
        const { data } = await getCustomerOverview(this.$route.params.id)
        this.formModel.forEach((item, index) => {
          if (item.key === 'companyName') {
            this.formModel.splice(index, 1, {
              ...item,
              value: data.base.englishName,
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async validate() {
      const valid = await this.$refs.form.validateFields()
      if (valid) {
        const result = this.$refs.form.getFormData()
        result.country = this.countryList.filter(
          item => item.id === result.country,
        )[0].mark
        return result
      }
    },
    async _getCountryList() {
      try {
        const { data } = await getSelectList('Country')
        this.formModel[0].selectList = data
        this.countryList = data
      } catch (err) {
        console.error(err)
      }
    },
  },
}
</script>
